import styled from '@emotion/styled';
import { Box } from '@kc-console/common-ui';
import { useTranslation } from '@kc-console/core';
import { IcChevronsLeftLargeRegular, IcChevronsRightLargeRegular } from '@kep/kcds-icons';

interface Props {
  collapsed: boolean;
  onCollapse: () => void;
}

export default function CollapsedButton({ collapsed, onCollapse }: Props) {
  const { t } = useTranslation();

  return (
    // 아이콘 전용 버튼이라 텍스트가 없으므로 aria-label로 접근 가능한 이름을 제공한다.
    <CollapsedButtonContainer
      type="button"
      aria-label={
        collapsed
          ? t('ui:collapsible_panel.left.expand_label')
          : t('ui:collapsible_panel.left.collapse_label')
      }
      onClick={onCollapse}
    >
      <CollapsedButtonIconContainer>
        {collapsed ? <IcChevronsRightLargeRegular /> : <IcChevronsLeftLargeRegular />}
      </CollapsedButtonIconContainer>
    </CollapsedButtonContainer>
  );
}

const CollapsedButtonIconContainer = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
`;

const CollapsedButtonContainer = styled.button`
  display: flex;
  justify-content: end;
  align-items: center;
  height: 40px;
  padding: 0 16px;
  border: none;
  background-color: ${({ theme }) => theme.color['surface/neutral/default']};
  cursor: pointer;
  transition: 200ms;

  /* hover 상태 */

  &:hover {
    background-color: ${({ theme }) => theme.color['surface/neutral/hover']};
  }

  /* active 상태 */

  &:active {
    background-color: ${({ theme }) => theme.color['surface/neutral/press']};
  }

  /* focus 상태 */

  &:focus-visible {
    position: relative;
    ${({ theme }) => theme.mixins.focusRing('inside')};
  }
`;
